module.exports = __webpack_public_path__ + "static/cell-8f636826ace8bd4220bbebae0b943f86.png";